import { TokensType } from '../../common/authProvider';

/**
 * Stcoke dans le local storage les informations nécessaires
 * @param tokens Les différents token keycloak
 * @param expireAt Date d'expiration de l'access token
 * @param email L'email de l'utilisateur
 * @param roles les roles de l'utilisateur
 */
export const setAuthenticationSuccessInfo = (
    tokens: TokensType,
    expireAt: number | undefined,
    email: string,
    roles: string[] | undefined
) => {
    localStorage.setItem(
        'sso-response',
        JSON.stringify({
            access_token: tokens.token,
            id_token: tokens.idToken,
            refresh_token: tokens.refreshToken,
            expires_at: expireAt,
            email: email,
            roles: roles
        })
    );
};
